import { Stack, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import { useParams } from 'react-router-dom'

import PageSection, { ErrorSection } from 'components/common/PageSection'
import { useGetSharedAssets } from 'queries/sharedAssets/use-get-shared-assets'

export const ManageClusterAccessPage: React.FC = () => {
  const { assetId } = useParams()

  const {
    data: sharedAssetById,
    isLoading: isLoadingSharedAssets,
    isError: isErrorSharedAssets,
    error: sharedAssetsError
  } = useGetSharedAssets({
    enabled: Boolean(assetId)
  })

  const assetName = useMemo(() => {
    if (!assetId) {
      return null
    }

    const sharedAsset = sharedAssetById?.myClusters.find(
      (asset) => asset.assetId === assetId
    )

    if (!sharedAsset) {
      return null // Fallback to displaying the assetId param if sharedAsset is not found
    }

    return sharedAsset.clusterName
  }, [assetId, sharedAssetById?.myClusters])

  return (
    <PageSection
      errorMessage={sharedAssetsError}
      hasError={isErrorSharedAssets}
      isLoading={isLoadingSharedAssets}
    >
      {() => {
        if (!assetName) {
          return (
            <ErrorSection message="Unable to find the cluster name for the given asset ID." />
          )
        }

        return (
          // TODO: useFlexGap
          <Stack sx={{ rowGap: 4 }}>
            <Stack sx={{ rowGap: 2 }}>
              <Typography variant="h5">{assetName} management</Typography>
              <Typography>Manage team namespace access</Typography>
            </Stack>
            <Typography>Manage Cluster Access Team List Placeholder</Typography>
          </Stack>
        )
      }}
    </PageSection>
  )
}
